import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { bindActionCreators } from 'redux'
import { checkGuestExists, updatePin, updateGuestId, updateGuestIdFromPath, checkGuestPin, toggleAcceptTerms, submitGuestForm, reset } from '../../reducers/guest'


const styles = theme => ({
  root: {
    width: '90%',
  },
  button: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  actionsContainer: {
    marginBottom: theme.spacing.unit * 2,
  },
  resetContainer: {
    padding: theme.spacing.unit * 3,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  }
});
function isValidForm({ termsAccepted }) {
  return termsAccepted;
}
function isValidPin(pin) {
  const pin_regex = /^[0-9]{4}$/i
  const match = pin.match(pin_regex);
  return match && match[0] === pin;
}
function isValidGuid(guid) {
  const guid_regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  const match = guid.match(guid_regex);
  return match && match[0] === guid;
}
function getSteps() {
  return ['Fetch pass', 'Enter pin', 'Agree to terms', 'Get pass'];
}

class GuestPage extends React.Component {
  state = {
    activeStep: 0,
  };
  componentDidMount() {
    this.props.updateGuestIdFromPath();
  }
  getStepContent(step) {
    switch (step) {
      case 0:
        return <div><TextField
          fullWidth
          id="guest_id"
          label="Pass ID"
          className={this.props.classes.textField}
          value={this.props.guest_id}
          onChange={this.props.updateGuestId}
          margin="normal"
        />
          <Button
            disabled={this.props.checkingGuestExists || !isValidGuid(this.props.guest_id)}
            onClick={this.props.checkGuestExists}
            className={this.props.classes.button}
          >
            Submit
        </Button>
        </div>
      case 1:
        return <div><TextField
          id="pin"
          label="Pin"
          className={this.props.classes.textField}
          value={this.props.pin}
          onChange={this.props.updatePin}
          margin="normal"
        />
          <Button
            disabled={this.props.checkingGuestPin || !isValidPin(this.props.pin)}
            onClick={this.props.checkGuestPin}
            className={this.props.classes.button}
          >
            Submit
          </Button>
        </div>
      case 2:
        return <div>
          <Typography component="p">
            {`Hi ${this.props.guest_name}!`}
            <br/>
            {`We're glad you're visiting our community. As a courtesy to our residents, we do ask that you park your car
              in the designated 'Visitor' spots - just drive around the corner, they're impossible to miss.`}
            <br/>
            {`Enjoy your time!`}
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.props.form.termsAccepted}
                onChange={this.props.toggleAcceptTerms}
                value="termsAccepted"
              />
            }
            label="I accept the terms"
          />
          <Button
            disabled={this.props.submittingGuestForm || !isValidForm(this.props.form)}
            onClick={this.props.submitGuestForm}
            className={this.props.classes.button}
          >
            Submit
          </Button>
        </div>;
      case 3:
        return <div>
          <Typography>
            {this.props.gateCode}
          </Typography>
          <Button
            onClick={this.props.reset}
            className={this.props.classes.button}
          >
            Reset
        </Button>
        </div>
      default:
        return 'Unknown step';
    }
  }
  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const activeStep = getActiveStep(this.props);
    return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <div className={classes.actionsContainer}>
                    {this.getStepContent(index)}
                  </div>
                </StepContent>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length && (
          <Paper square elevation={0} className={classes.resetContainer}>
            <Typography>All steps completed - you&quot;re finished</Typography>
            <Button onClick={this.props.reset} className={classes.button}>
              Reset
            </Button>
          </Paper>
        )}
      </div>
    );
  }
}


function getActiveStep({ guestExists, guestPinIsValid, guestFormSubmitted }) {
  if (!guestExists) return 0;
  if (!guestPinIsValid) return 1;
  if (!guestFormSubmitted) return 2;
  return 3;
}
GuestPage.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      guest_id: PropTypes.string
    })
  }),
  guest_id: PropTypes.string,
  updateGuestId: PropTypes.func.isRequired,
  updateGuestIdFromPath: PropTypes.func.isRequired,
  checkGuestExists: PropTypes.func.isRequired,
  checkingGuestExists: PropTypes.bool.isRequired,
  checkedGuestExists: PropTypes.bool.isRequired,
  guestExists: PropTypes.bool.isRequired,
  pin: PropTypes.string.isRequired,
  updatePin: PropTypes.func.isRequired,
  checkGuestPin: PropTypes.func.isRequired,
  checkingGuestPin: PropTypes.bool.isRequired,
  checkedGuestPin: PropTypes.bool.isRequired,
  guestPinIsValid: PropTypes.bool.isRequired,
  guest_name: PropTypes.string.isRequired,
  form: PropTypes.shape({
    termsAccepted: PropTypes.bool.isRequired
  }),
  toggleAcceptTerms: PropTypes.func.isRequired,
  submitGuestForm: PropTypes.func.isRequired,
  submittingGuestForm: PropTypes.bool.isRequired,
  guestFormSubmitted: PropTypes.bool.isRequired,
  gateCode: PropTypes.string.isRequired
  /// other
}
const mapStateToProps = ({ guest }) => ({
  checkedGuestExists: guest.checkedGuestExists,
  guest_id: guest.guest_id,
  checkingGuestExists: guest.checkingGuestExists,
  guestExists: guest.guestExists,
  checkedGuestPin: guest.checkedGuestPin,
  pin: guest.pin,
  checkingGuestPin: guest.checkingGuestPin,
  guestPinIsValid: guest.guestPinIsValid,
  guest_name: guest.guest_name,
  guestFormSubmitted: guest.guestFormSubmitted,
  submittingGuestForm: guest.submittingGuestForm,
  form: guest.form,
  gateCode: guest.gateCode
});
const mapDispatchToProps = dispatch => bindActionCreators({
  checkGuestExists,
  updatePin,
  updateGuestId,
  updateGuestIdFromPath,
  checkGuestPin,
  toggleAcceptTerms,
  submitGuestForm,
  reset
}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(GuestPage));


// WEBPACK FOOTER //
// ./src/pages/guest/index.js